import React, { useEffect, useState } from 'react'

import { getInventoryPrograms } from 'api'

import { ProgramCard } from './components/Card'
import { CalculatorLink, CardsContainer } from './styles'

import {
  ACTIVE_CARE_LINK_CARDS,
  DAYCARE_CALCULATOR_URL,
  batchTypesProgramFlow
} from '../../constants'
import { transformProgramCards } from '../../transformers'
import { ActiveCareLinkModal } from '../ActiveCareLinkModal'

const ProgramCards = ({ selectedBatchType, selectedCentres, onCardClick }) => {
  const [programCardsData, setProgramCardsData] = useState([])
  const [activeCareLinkPlan, setActiveCareLinkPlan] = useState(null)
  const isActiveCare = selectedBatchType === batchTypesProgramFlow.CARE

  useEffect(() => {
    ;(async () => {
      // Active Care is booked only through the link cards below; the payment
      // enrols the child in the centre's Active Care batch.
      if (selectedCentres && !isActiveCare) {
        const programsResponse = await getInventoryPrograms({
          queries: {
            type: selectedBatchType,
            centre_uuid: selectedCentres?.value ?? undefined
          }
        })
        setProgramCardsData(transformProgramCards(programsResponse))
      }
    })()
  }, [selectedCentres, selectedBatchType, isActiveCare])

  const cards = isActiveCare ? ACTIVE_CARE_LINK_CARDS : programCardsData

  return (
    <>
      {isActiveCare && (
        <CalculatorLink
          href={DAYCARE_CALCULATOR_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open the daycare calculator ↗
        </CalculatorLink>
      )}
      <CardsContainer>
        {cards?.map((card) => (
          <ProgramCard
            onCardClick={() =>
              card.linkPlan
                ? setActiveCareLinkPlan(card.linkPlan)
                : onCardClick(card)
            }
            card={card}
            key={card.uuid}
          />
        ))}
        <ActiveCareLinkModal
          open={!!activeCareLinkPlan}
          plan={activeCareLinkPlan}
          centre={selectedCentres}
          onClose={() => setActiveCareLinkPlan(null)}
        />
      </CardsContainer>
    </>
  )
}
export default ProgramCards
